import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const crearDocumento = async (documento) => {
    try {
      const {data}  = await Axios.post(
        '/documento', documento
      );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const creaDocumentoFinal = async (documento) => {
    try {
      const {data}  = await Axios.post(
        '/documento/final', documento
      );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateDocumentoFinal = async (documento) => {
    try {

     // console.log(' ENVIAR ' + documento._id);
      const {data}  = await Axios.patch(
        `/documento/entregado/${documento._id}`, documento
      );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getDocumentosFiltros = async (tipoDocumento,cliente,rutEmpresa, razonSocial, fechaStart,fechaEnd , estado) => {
    try {
      const userInfo = fetchUser();

      const {data}  = await Axios.get(
        `/documento?empresa=${userInfo.empresa}&tipoDocumento=RES&cliente=${cliente}&rutEmpresa=${rutEmpresa}&razonSocial=${razonSocial}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getDocumentosMatriz = async (tipoDocumento, fechaStart,fechaEnd , estado) => {
    try {
      const userInfo = fetchUser();

      const {data}  = await Axios.get(
        `/documento/reporte?empresa=${userInfo.empresa}&tipoDocumento=RES&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };



  export const ProcesaDocumentoLegalId = async ( _id ) => {
    try {
      const userInfo = fetchUser();
        const {data}  = await Axios.get(
        `/documento/procesar?empresa=${userInfo.empresa}&tipoDocumento=RES&id=${_id}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const ProcesaDocumentoLegalIdNoDelete = async ( _id ) => {
    try {
      const userInfo = fetchUser();
        const {data}  = await Axios.get(
        `/documento/procesarnodelete?empresa=${userInfo.empresa}&tipoDocumento=RES&id=${_id}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };
  

  export const getDocumentoLegalId = async ( _id ) => {
    try {
        const {data}  = await Axios.get(
        `/documento/uno?id=${_id}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getDocumentoFinalId = async ( _id ) => {
    try {
        const {data}  = await Axios.get(
        `/documento/final?id=${_id}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getDataDashboard = async (cliente,fechaStart,fechaEnd ) => {
    try {
      const userInfo = fetchUser();

      const {data}  = await Axios.get(
        `/documento/dashboard?empresa=${userInfo.empresa}&cliente=${cliente}&fechaInicio=${fechaStart}&fechaFin=${fechaEnd}`);
        return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const deleteDocumento = (Id) => Axios.delete(`/documento/${Id}`);

  export const getNextFolio = async (tipoDocumento) => {
    try {
        const userInfo = fetchUser();
        const {data}  = await Axios.get(
          `/folios?empresa=${userInfo.empresa}&sucursal=${userInfo.sucursal}&tipoDocumento=${tipoDocumento}`
        );
        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
    };